// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"44e01f68","44":"d30c024d","157":"94e8dec7","372":"91187c36","473":"060d3d14","499":"b6590c47","537":"751dc308","595":"20ad8047","638":"92dd8c32","869":"50d0d6f6"}[chunkId] + ".chunk.js";
};